<template>
  <div id="exchange-rate-input">
    <!-- <p class="exchange-rate-description mb-0 mt-1">
      <span class="mr-2">
        {{ $t(`views.common.exchangeRateInput.description`) }}
      </span>
      <InfoIcon :text="textInfoIcon" />
    </p> -->
    <div class="exchange-rate-input-flex mt-1">
      <template v-if="!notAllowRotate">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              size="30"
              class="mr-3 mt-2"
              @click="$emit('rotateExchangeRatePair')"
              v-on="on"
            >
              mdi-swap-vertical
            </v-icon>
          </template>
          <span>{{ $t('views.common.exchangeRateInput.changePair') }}</span>
        </v-tooltip>
      </template>

      <v-text-field
        v-model="myValue"
        type="number"
        :label="
          exchangeRatePair
            ? `${$t('views.common.exchangeRateInput.label')} (${exchangeRatePair})`
            : $t('views.common.exchangeRateInput.label')
        "
        :placeholder="exchangeRatePair"
        :disabled="disabled"
        hide-details
      />
    </div>
  </div>
</template>

<script>
import InfoIcon from '@/views/components/common/InfoIcon'

export default {
  components: { InfoIcon },
  props: {
    value: {
      type: null,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    exchangeRatePair: {
      type: String,
      default: null,
    },
    notAllowRotate: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    myValue: null,
  }),
  computed: {
    textInfoIcon() {
      return (
        this.$t(`views.common.exchangeRateInput.info`) +
        ' ' +
        this.$t(`views.common.exchangeRateInput.info2`) +
        ' ' +
        this.$t(`views.common.exchangeRateInput.info3`)
      )
    },
  },
  watch: {
    value: {
      handler() {
        this.myValue = this.value
      },
      immediate: true,
    },
    myValue() {
      this.$emit('input', this.myValue)
    },
  },
}
</script>

<style lang="scss">
#exchange-rate-input {
  .exchange-rate-description {
    font-size: 13px;
    text-align: justify;
  }

  .exchange-rate-input-flex {
    display: flex;
    align-items: center;
  }
}
</style>
